import { useState } from 'react';
import style from './FAQSection.module.css';

const faqData = [
	{
	  question: "What is a Global Capability Center?",
	  answer:
		'A Global Capability Center (GCC), commonly referred to as a Captive Center or Global In-House Center (GIC), leverages the global talent pool and cost efficiency of the regions they operate in. A GCC is an offshore or nearshore entity fully owned and operated by a parent company. These centers provide a wide array of specialized services, ranging from information technology (IT) and research and development (R&D) to complex back-office functions. GCCs play a pivotal role in driving innovation, enhancing cost efficiency, and accessing diverse global talent pools at optimal cost.',
	},
	{
	  question: "Why is India the GCC hub?",
	  answer:
		'India is still recognized as the GCC capital of the world due to its large global talent pool, robust infrastructure, cost-effectiveness, government policies, and culture of innovation. Currently, India hosts over 2,117 GCCs, employing more than 2.36 million professionals.',
	},
	// {
	//   question: "What is the future growth outlook for GCCs?",
	//   answer:
	// 	"By 2030, India is expected to be home to 2,100-2,200 GCCs, employing around 2.5-2.8 million professionals.",
	// },
	{
	  question: "What is the market size for GCCs in India?",
	  answer:
		"The current market size of India's GCC ecosystem stands at $98.4 billion.",
	},
	{
	  question: "Which city is the GCC capital of India?",
	  answer:
		"Bengaluru is the GCC capital of India, also known as the 'Silicon Valley of India,' due to its thriving ecosystem, robust infrastructure, access to a deep talent pool, and an environment that fosters mobility and innovation. It hosts more than 880 GCCs in India, accounting for almost 29% of the total GCCs in the country.",
	},
	{
	  question: "Which cities are the emerging GCC hubs in India?",
	  answer:
		'Along with Bengaluru, Hyderabad is gaining momentum as a GCC hub due to its world-class infrastructure for office spaces, strong digital connectivity, SEZs, and business-friendly policies. Hyderabad is home to over 355 GCCs, accounting for almost 21% of the total GCCs in India. Emerging Tier I GCC cities include Chennai, Mumbai, and NCR, collectively contributing close to 92% of total GCCs in India.',
	},
	{
	  question: "How does Zinnov help in GCC setup?",
	  answer:
		"With 24+ years of expertise in setting and transforming 220+ GCCs, Zinnov's approach to a frictionless GCC setup has helped customers reduce time to set up and time to value by 50%. The proven GCC-as a service model- Design, Implementation, and Governance, ensures hassle-free setup and operations.",
	}
  ];
  
  

const FAQSection = () => {
	const [activeIndex, setActiveIndex] = useState(null);
  
	const toggleAccordion = (index) => {
	  setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
	};
  
	return (
	  <section id={style.faqSection} className={style.sectionPadding}>
		<div className={style.container}>
		  <div className={style.row}>
			<div className={style.sectionHeading}>
			  <h4 className={`${style.sectionTitle} Heading Title ${style.textWhite}`}>FAQs</h4>
			</div>
			<div id="accordion" className={`${style.myaccordion} ${style.faqAccordion}`}>
			  {faqData.map((faq, index) => (
				<div className={style.card} key={index}>
				  <div className={style.cardHeader}>
					<button
					  className={`${style.btn} ${activeIndex === index ? style.active : ""}`}
					  onClick={() => toggleAccordion(index)}
					  aria-expanded={activeIndex === index}
					  aria-controls={`collapse_${index}`}
					>
					  <span className={style.icon}>
						{activeIndex === index ? "-" : "+"}
					  </span>
					  <p>{faq.question}</p>
					</button>
				  </div>
				  <div
					id={`collapse_${index}`}
					className={`${style.collapse} ${activeIndex === index ? style.show : ""}`}
					aria-labelledby={`heading${index}`}
					>
					<div className={style.cardBody} dangerouslySetInnerHTML={{ __html: faq.answer }} />
					</div>
				</div>
			  ))}
			</div>
		  </div>
		</div>
	  </section>
	);
  };
  
  export default FAQSection;